
export default {
  props: {
    id: { type: [String, Number], default: null },
    name: { type: String, default: null },
    recipe: { type: String, default: null },
    background: { type: Object, default: null },
    backgroundDefault: { type: Object, default: null },
    packshot: { type: Object, default: null },
  },

  computed: {
    backgroundFinal() {
      return this.background && this.background.origin ? this.background : this.backgroundDefault
    }
  }
}
